import { Separator as BaseSeparator } from '@base-ui/react/separator';
import type { ComponentProps } from 'react';
import { cx } from '../lib/styled.tsx';

export type SeparatorProps = ComponentProps<typeof BaseSeparator>;

/** A hairline between groups of content, hidden from assistive tech. */
export function Separator({ className, ...props }: SeparatorProps) {
  return (
    <BaseSeparator
      className={cx(
        'shrink-0 bg-border-subtle',
        'data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full',
        'data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px',
        className,
      )}
      {...props}
    />
  );
}
